import React from "react"
import PatientSummary from "./ExpandedView/PatientSummary"
import UtilizationSummary from "./ExpandedView/UtilizationSummary"
import NurseSummary from "./ExpandedView/NurseSummary"
import NurseScheduler from "./ExpandedView/ReactiveNurseChart"
import FuturePatientList from "./ExpandedView/FuturePatientList"
import SchedulingIssues from "./ExpandedView/ScheduleIssuesMap"
import FutureNotesSection from "./ExpandedView/FutureNotesSection"
import { FaArrowLeft, FaCalendarDay } from "react-icons/fa"
import useFetchFutureSchedules from "../../hooks/useFetchSchedules/useFetchFutureSchedules"
import useFetchFutureHuddle from "../../hooks/useFetchFutureHuddle"
import { PageLoader } from "../Authentication/page-loader"

const ExpandedView = ({ day, onBack, settings }) => {
	// if (!day) return null

	// Get future huddle data from React Query cache
	const { futureHuddleData } = useFetchFutureHuddle()

	// Fetch schedule data for the selected day
	const { data: scheduleData, isLoading } = useFetchFutureSchedules(settings, day.date)
	const scheduleForDate = scheduleData[day.date] || []
	const patients = scheduleForDate.patients || []

	const dateObj = new Date(day.date + "T00:00:00")
	const dayOfWeek = dateObj.toLocaleDateString(undefined, { weekday: "long" })
	const dateStr = dateObj.toLocaleDateString(undefined, {
		year: "numeric",
		month: "long",
		day: "numeric"
	})

	// Show loading state while fetching patients
	if (isLoading) {
		return <PageLoader />
	}

	return (
		<div className="p-6">
			<button
				className="flex items-center px-3 py-1.5 rounded-full text-sm font-medium transition-colors duration-150 group mb-4"
				onClick={onBack}
				style={{
					background:
						"linear-gradient(90deg, rgba(99,102,241,0.1) 0%, rgba(99,102,241,0.05) 100%)",
					borderColor: "rgba(99,102,241,0.2)",
					color: "rgb(99,102,241)",
					border: "1px solid rgba(99,102,241,0.2)"
				}}
			>
				<FaArrowLeft className="mr-2" />
				Back to Weekly View
			</button>
			<h2 className="text-2xl font-bold mb-6 flex items-center">
				<FaCalendarDay className="mr-2 text-blue-600" />
				<span>
					{dayOfWeek}, {dateStr}
				</span>
			</h2>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
				<NurseSummary day={day} />
				<PatientSummary day={day} />
				<UtilizationSummary day={day} />
			</div>

			{/* Notes Section */}
			<div className="mt-6">
				<FutureNotesSection day={day} futureHuddleData={futureHuddleData} />
			</div>

			{/* Nurse staffing full-width so long nurse names are fully visible */}
			<div className="mt-6">
				<NurseScheduler day={day} settings={settings} />
			</div>

			{/* Scheduling alerts stacked beneath the staffing table */}
			<div className="mt-6">
				<SchedulingIssues issues={day.schedulingIssues || []} />
			</div>

			{/* Future Patient List Row */}
			<div className="mt-6">
				<FuturePatientList
					patients={patients}
					schedulingIssues={day.schedulingIssues || []}
				/>
			</div>
		</div>
	)
}

export default ExpandedView
